module.exports = __webpack_public_path__ + "media/images/redesign-images/higher-ed/event-09-8025cec11e3cee1a592c0a636c694db6.jpg";